export const diagnosisTicketCreatedStorageKey =
  "bitsentry:diagnosis-ticket-created";

export function notifyDiagnosisTicketCreated(): void {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.setItem(
      diagnosisTicketCreatedStorageKey,
      window.crypto.randomUUID(),
    );
  } catch {
    // The current tab still invalidates its own queries; polling covers others.
  }
}

export function onDiagnosisTicketCreated(
  listener: () => void,
): () => void {
  if (typeof window === "undefined") return () => undefined;

  const handleStorage = (event: StorageEvent) => {
    if (event.key === diagnosisTicketCreatedStorageKey) listener();
  };
  window.addEventListener("storage", handleStorage);

  return () => window.removeEventListener("storage", handleStorage);
}
